import { makeStyles, Text } from "@fluentui/react-components";
import { Link } from "react-router-dom";
import TitleText from "../../../components/titleText/TitleText";
import IPageCTABanner from "../../../models/page/pageComponents/IPageCTABanner";
import { dolphinTokens } from "../../../utils/Theme";

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "4rem 2rem",
        maxWidth: "900px",
        margin: "0 auto",
        gap: "1.5rem",
    },
    button: {
        display: "inline-block",
        padding: "0.85rem 2.5rem",
        borderRadius: "8px",
        backgroundColor: dolphinTokens.colorLightBlue,
        color: "#ffffff",
        fontWeight: "600",
        fontSize: "1rem",
        textDecoration: "none",
        transition: "opacity 0.2s",
        ":hover": {
            opacity: "0.85",
            textDecoration: "none",
            color: "#ffffff"
        }
    }
});

export default function CTABanner(props: IPageCTABanner) {
    const styles = useStyles();

    return (
        <div className={styles.container}>
            <TitleText
                title={props.title}
                titleHighlightedWords={props.titleHighlightedWords}
                subtitle={props.subtitle}
                alignment="center"
                width="100%"
            />
            {props.buttonText && props.buttonUrl && (
                <Link to={props.buttonUrl} className={styles.button}>
                    <Text>{props.buttonText}</Text>
                </Link>
            )}
        </div>
    );
}
